import React from 'react';
import './sign-in-and-sign-up.placement.styles.scss';
import SignIn from '../../general/sign-in/sign-in.component';
import Padding from '../../../general/padding/Padding';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';
import Divider from '@mui/material/Divider';

const SignInAndSignUp = ({firstSignText, heading}) => {
   
    const location = useLocation();
    const currentPath = location.pathname.substring(1,location.pathname.lastIndexOf('/'));//to get only the current path till student/faculty portal
    // console.log(currentPath);
    
    return(
        <Grid container className="sign-in-and-sign-up" spacing={20} justifyContent="center">
        <Padding />
        <Grid item sx={{width:'100%',textAlign:'center',padding:0,margin:0}} justifyContent="center">
        <Typography variant="h3" sx={{fontFamily:'Montserrat'}}>{heading}</Typography>
        </Grid>

        <Grid item style={{padding:'4%'}}> 
        <SignIn buttonLink='dashboard/faculty' secondSignText={firstSignText} />
        </Grid>
        <Divider orientation="vertical" flexItem/>
        </Grid>
    )
}

export default SignInAndSignUp; 